const isNumeric = function (n) {
  return !Number.isNaN(parseFloat(n)) && Number.isFinite(n)
};

export default isNumeric;
